import React from 'react';
import { useSelector } from 'react-redux';
import {
	selectors as profileSelectors,
	hooks as profileHooks,
} from '@src/containers/ProfileVenue';
import FilesList from '@src/components/FilesList';
import PackagesModal from '..';

const PackagesModalCVenueProfile = () => {
	const { setActivePack } = profileHooks.useActions();
	const packs = useSelector(profileSelectors.mappedPacks);
	const packId = useSelector(profileSelectors.activePackId);
	const isOpened = packId !== null;
	const targetPack = packs.find(({ id }) => id === packId);
	const { files = [] } = targetPack || {};

	const FilesListComp = React.useCallback(() => {
		return <FilesList files={files} />;
	}, [files]);

	const handleClose = React.useCallback(() => {
		setActivePack({ id: null });
	}, [setActivePack]);

	if (!isOpened) {
		return null;
	}

	return (
		<PackagesModal
			title={targetPack.title}
			onClose={handleClose}
			previews={targetPack.previews}
			params={targetPack.params}
			contentBlocks={targetPack.contentBlocks}
			FilesList={files.length > 0 ? FilesListComp : null}
		/>
	);
};

PackagesModal.propTypes = {};

PackagesModal.defaultProps = {};

export default PackagesModalCVenueProfile;
